
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provenance",
      function () {
        return require("private-next-pages/provenance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provenance"])
      });
    }
  